import { FormGroup } from "@angular/forms";
import { Directive, Input } from "@angular/core";



@Directive()
export class BaseFormComponent {
    valueChangedEvents: ((value: Record<string, unknown>) => void)[];

    @Input()
    set value(value: Record<string, unknown>) {
        this.innerValue = value;
        this._onValueChanged(this.innerValue);
    }
    get value(): Record<string, unknown> { return this.innerValue; }

    form: FormGroup;


    innerValue: Record<string, unknown> = {}

    constructor() {
        this.valueChangedEvents = [];
    }

    private _onValueChanged(value: Record<string, unknown>) {
        this.valueChangedEvents.forEach(p => {
            p(value);
        })
    }

    onValueChanged(func: (value: Record<string, unknown>) => void) {
        this.valueChangedEvents.push(func);
    }

    getErrorMessage(fieldName: string) {

        const field = this.form.get(fieldName);

        if (field.invalid) {

            if (field.hasError('required') && fieldName === 'eventDates') {
                return 'please select the event dates.';
            }

            if (field.hasError('required')) {
                return 'please enter a value.';
            }
            if (field.hasError('email')) {
                return 'please enter a valid email address.';
            }

            if (field.hasError('number')) {
                return 'please provide a valid number.';
            }

            if (field.hasError('url')) {
                return 'please provide a valid url.';
            }

            if (field.hasError('admissionPrice')) {
                return 'highest value must be higher or equal to lowest value.';
            }

            if (field.hasError('eircode')) {
                return 'please provide a valid eircode.';
            }

            if (field.hasError('contact')) {
                return 'please provide a valid contact number. (e.g. +353871234567)';
            }

            if (field.hasError('invalidCounty')) {
                return 'please provide a valid county for the town selected.';
            }

            if (field.hasError('dates-duration')) {
                return 'you cannot create events with duration more than one year. if you need it, please contact the administrator via Contact Us option.';
            }

            if (field.hasError('pattern')) {
                if (field.errors && field.errors.pattern && field.errors.pattern.message) {
                    return field.errors.pattern.message;
                }
                return 'invalid value';
            }

            if (field.hasError('whitespace')) {
                if (field.errors && field.errors.whitespace && field.errors.whitespace.message) {
                    return field.errors.whitespace.message;
                }
                return 'this property is required';
            }

            if (field.hasError('caption')) {
                return 'please provide a caption with maximum of 255 characters.';
            }

            if (field.hasError('whitespaces')) {
                return 'whitespaces is not a valid value to this field.';
            }

            if (field.hasError('dates')) {
                return 'End Date must be higher or equal to Start Date.'
            }

            if (field.hasError('pastDate')) {
                return 'Cannot use past dates.'
            }

            if (field.hasError('invalid-date')) {
                return 'Invalid date value.'
            }

            if (field.hasError('maxlength') && fieldName == "teaser") {
                return 'Maximum number of characters exceeded: 250'
            }

            if (field.hasError('maxlength') && fieldName == "metadescription") {
                return 'Maximum number of characters exceeded: 140'
            }

            if (field.hasError('minlength') && fieldName == "metadescription") {
                return 'Minimum number of characters required: 25'
            }

            if (field.hasError('maxlength') && fieldName == "description") {
                return 'Maximum number of characters exceeded: 750'
            }

            if (field.hasError('minlength') && (fieldName == 'description' || fieldName == 'teaser')) {
                return "A minimum of 100 characters is required for this field.";
            }

            if (field.hasError('minlength') && (fieldName.startsWith('imagetitle'))) {
                return "A minimum of 25 characters is required for this field.";
            }

            if (field.hasError('maxlength') && fieldName.startsWith("imagetitle")) {
                return 'Maximum number of characters exceeded: 50'
            }

            if (field.hasError('minlength') && (fieldName.startsWith('imagedescription'))) {
                return "A minimum of 25 characters is required for this field.";
            }

            if (field.hasError('maxlength') && fieldName.startsWith("imagedescription")) {
                return 'Maximum number of characters exceeded: 240'
            }

            if (field.hasError('invalidAreaCode')) {
                return 'Invalid area code for the given country code.'
            }

            if (field.hasError('invalidUrlLength')) {
                return 'Hyperlink must have less than 450 characters.'
            }

            if (field.hasError('conditionalRequired') && fieldName == "videoCaption") {
                return 'Please provide a video caption to describe the video.'
            }

            return "requires your attention"
        }
        return "";
    }

    trimValue(event, formControlName, controlType = null) {
        try{
        let value = event.target.value.trim();

        if (controlType && controlType == "phone") {
            if (value == "+353" || value == "+44") {
                value = "";
            }
        }

        event.target.value = value;

        const formControl = this.form.get(formControlName);

        if (formControl && (value != undefined
            // && value != "" && value.length > 0
        )) {
            formControl.setValue(value);
            formControl.updateValueAndValidity();
            formControl.markAsTouched();
        }
        }catch(error){
            console.error(`Error trimValue: ${error}`);
            throw error;
        }
    }


    prefillphone(event, formControlName) {
        let value = event.target.value;

        if (value == "") {
            value = "+353";

            const formControl = this.form.get(formControlName);
            formControl.setValue(value);
            formControl.updateValueAndValidity();
            formControl.markAsTouched();
        }
    }

    prepareUrl(event, formControlName) {
        let value = event.target.value.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            value = 'https://' + value;
        }
        event.target.value = value;
        const formControl = this.form.get(formControlName);
        if (formControl) {
            formControl.setValue(value);
            formControl.updateValueAndValidity();
            formControl.markAsTouched();
        }
    }
}